<template>
  <h2>Messdienerplan vom {{ new Date(schedule.startDate).toLocaleDateString() }} bis zum
    {{ new Date(schedule.endDate).toLocaleDateString() }}</h2>
  <div class="fst-italic">{{ schedule.annotation }}</div>
  <div class="d-flex justify-content-between">
    <div class="btn-group pb-3">
      <schedule-create-edit-modal :pass-in-schedule="schedule" trigger-class="btn-warning" trigger-icon="create"
                                  trigger-text=""></schedule-create-edit-modal>
      <button :disabled="this.scheduleStore.currently_scheduling" class="btn btn-warning"
              @click.stop="reschedule(false)">
        <em class="align-middle material-icons">refresh</em></button>
      <button :disabled="this.scheduleStore.currently_scheduling" class="btn btn-success"
              @click.stop="reschedule(true)">
        <em class="align-middle material-icons">update</em></button>
      <button class="btn btn-success" @click.stop="this.scheduleStore.copySchedule(this.scheduleId)"><em
          class="align-middle material-icons">content_copy</em></button>
      <button class="btn btn-success" @click.stop="this.scheduleStore.downloadSchedule(this.scheduleId)"><em
          class="align-middle material-icons">download</em></button>
      <router-link :to="{name: 'PlanStatistik', params: {id: this.scheduleId}}" class="btn btn-primary"><em
          class="align-middle material-icons">insights</em></router-link>
      <router-link :to="{name: 'PlanAnmerkungen', params: {id: this.scheduleId}}" class="btn btn-primary"><em
          class="align-middle material-icons">edit_note</em></router-link>
    </div>
    <button v-if="!fullScreenMode" class="btn btn-outline" @click="fullScreenMode = true"><em
        class="align-middle material-icons">fullscreen</em></button>
  </div>
  <div class="row">
    <div class="col-auto">
      <label class="form-label" for="scheduling_mode">Planungs-Reihenfolge</label>
      <select id="scheduling_mode" v-model="schedulingMode" class="form-select">
        <option selected value="datetime">Nach Datum aufsteigend</option>
        <option value="smart_scheduling">Schwierige Messen zuerst</option>
      </select>
    </div>
  </div>
  <div :class="{'container-fluid, full-screen' : fullScreenMode}" class="card-group flex-nowrap">
    <mass-detail v-for="mass in schedule.mass_set" :key="mass" :mass-id="mass"
                 :hovered-altar-server-id="hoveredAltarServerId" :schedule-id="schedule.id"
                 :violations="violations[mass] || {}"
                 :style="{ 'flex-basis': fullScreenMode ? '0%' : '20%'}"
                 @hoverAltarServer="id => hoveredAltarServerId = id"></mass-detail>
  </div>
</template>

<script>
import MassDetail from "@/components/MassDetail";
import ScheduleCreateEditModal from "@/components/ScheduleCreateEditModal";
import {useAltarServerStore} from "@/stores/altarServer";
import {useScheduleStore} from "@/stores/schedule";
import {useMassStore} from "@/stores/mass";

export default {
  name: "ScheduleDetail",
  data: function () {
    return {
      schedule: {},
      violations: {},
      fullScreenMode: false,
      hoveredAltarServerId: null,
      schedulingMode: "datetime",
      scheduleId: Number(this.$route.params.id),
    }
  },
  methods: {
    async getViolations() {
      await this.axios.get(`/plaene/${this.scheduleId}/besetzung_pruefung/`).then((response) => {
        this.violations = response.data;
      }).catch((e) => {
        console.log(e);
      });
    },
    async reschedule(preserve_current_staffing) {
      await this.scheduleStore.reschedule(this.schedule, preserve_current_staffing, this.schedulingMode === "smart_scheduling");

      // Reload masses to make sure they show the new staffing
      await this.massStore.getData();
      await this.getViolations();
    },
  },
  created() {
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
    if (!this.massStore.loadedData)
      this.massStore.getData();
    if (!this.scheduleStore.loadedData)
      this.scheduleStore.getData();

    // Load schedule from schedule store
    this.schedule = this.scheduleStore.getItemById(this.scheduleId);

    // Fetch availability violations for the whole schedule in one bulk call
    this.getViolations();

    // Reload schedule when some schedule changed (this ensures reactivity but does not trigger HTTP requests)
    this.scheduleStore.$subscribe(() => {
      this.schedule = this.scheduleStore.getItemById(this.scheduleId);
    })

    window.addEventListener('keyup', e => {
      if (e.key === "Escape") this.fullScreenMode = false;
    })
  },
  components: {
    ScheduleCreateEditModal,
    MassDetail
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    const scheduleStore = useScheduleStore();
    const massStore = useMassStore();
    return {altarServerStore, scheduleStore, massStore};
  }
}
</script>

<style scoped>
.card-group {
  overflow-x: scroll;
}

.full-screen {
  position: absolute;
  overflow: unset;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>